import * as React from 'react';

import {IService} from '../../models/service';
import {ServiceBlockBottom} from './service_block_bottom';
import {ServiceBlockTop} from './service_block_top';

const s = require('./service_block.css');

interface IProps {
  onAdsClick(eventLabel: string): void;
  onPremClick(eventLabel: string): void;
  service: IService;
  coordinates?: {
    lat: number;
    lng: number;
  };
  section: string;
  onSendSMS: (phone: string) => void;
  onResendSMS: () => void;
}

export const ServiceBlock = (props: IProps) =>
  <div className={s['c-services']}>
    <ServiceBlockTop
      coordinates={props.coordinates}
      section={props.section}
      onAdsClick={(eventLabel: string) => props.onAdsClick(eventLabel)}
      onPremClick={(eventLabel: string) => props.onPremClick(eventLabel)}
    />
    <ServiceBlockBottom {...props} />
  </div>;
